import React from 'react'
import { Text } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import InputCell from '../InputCell/InputCell'
import StatusCell from '../StatusCell/StatusCell'
import ClickeableCell, {
  FillBalanceCell,
} from '../ClickeableCell/ClickeableCell'
import CardCell from '../CardCell/CardCell'
import RutCell from '../RutCell/RutCell'
import DateCell from '../DateCell/DateCell'
import RefillStatusCell from '../ClickeableCell/RefillStatusCell'
import DeleteRefillCell from '../ClickeableCell/DeleteRefillCell'
import DateHourCell from '../DateCell/DateHourCell'
import StatusCardCell from '../StatusCell/StatusCardCell'
// import { numberFormat } from '../../../../utils/formats/formats'

const endTypes = ['number', 'currency', 'oc', 'clickeable']

const tableComponents = {
  number: InputCell,
  status: StatusCell,
  statusCard: StatusCardCell,
  clickeable: ClickeableCell,
  currency: InputCell,
  fill_balance: FillBalanceCell,
  card: CardCell,
  dni: RutCell,
  date: DateCell,
  dateH: DateHourCell,
  refillStatus: RefillStatusCell,
  deleteRefill: DeleteRefillCell,
}

const CellFactory = ({ type, editable, componentProps, ...rest }) => {
  const finalType =
    type === 'dni' && componentProps?.value?.includes('NN') ? '' : type
  const CellComponent = tableComponents[finalType]
  if (CellComponent && (editable || !['number', 'currency'].includes(type))) {
    return <CellComponent {...componentProps} type={type} {...rest} />
  }
  return (
    <Text
      textAlign={endTypes.includes(type) ? 'end' : 'start'}
      variant={componentProps.textVariant || 'body2'}
    >
      {componentProps?.value}
    </Text>
  )
}

CellFactory.propTypes = {
  componentProps: PropTypes.object,
  editable: PropTypes.any,
  type: PropTypes.string,
}

export default CellFactory
